import { GridColumn, GridRow } from 'app/layouts/grid';
import { Button } from 'app/shared/button';
import { DetailItem } from 'app/shared/info-section/item';
import { SimpleInput } from 'app/shared/input';
import { MultiSelect } from 'app/shared/select';
import { useEventsService } from 'hooks/automation/event';
import { useAPI } from 'hooks/clients/api';
import { useKeyService } from 'hooks/key';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

export const ContactEventTrigger = ({ contact_data = {}, closeModal = () => {} }) => {
  const { triggerEvent } = useAPI();
  const { fetchEvents } = useEventsService();
  const { fetchKey } = useKeyService();

  const [api_key, setAPIKey] = useState('');
  const [events, setEvents] = useState([]);
  const [selected_event, setSelectedEvent] = useState({});

  useEffect(() => {
    fetchEvents({ query_string: 'type=user' }).then(({ events }) => {
      setEvents(events.map((e) => ({ ...e, label: e.name, value: e.code })));
    });

    fetchKey().then((response) => {
      const { key } = response;
      setAPIKey(key);
    });
  }, []);

  const submit = async () => {
    if (!selected_event.value) return toast.error('No event selected');
    const data = {
      event_code: selected_event.value,
      contact_email: contact_data.email,
      context: {}
    };

    await triggerEvent({ data, token: api_key });
  };

  return (
    <>
      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="Contact email">
            <SimpleInput value={contact_data.email} disabled />
          </DetailItem>
        </GridColumn>
      </GridRow>
      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="event">
            <MultiSelect options={events} value={selected_event} onChange={setSelectedEvent} />
          </DetailItem>
        </GridColumn>
      </GridRow>
      <GridRow num_of_columns={3}>
        <GridColumn span={2} />
        <GridColumn>
          <Button text="Trigger" onClick={submit} disabled={!selected_event.value} />
        </GridColumn>
      </GridRow>
    </>
  );
};
